import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './Card.module.scss';

/** `none` desliga a barra: cartão de conteúdo, sem sinalizar estado nenhum. */
export type CardAccent = 'brand' | 'success' | 'warning' | 'danger' | 'neutral' | 'none';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Cor da barra de categoria/status. */
  accent?: CardAccent;
  /** Posicao da barra colorida. */
  accentSide?: 'start' | 'top';
  title?: ReactNode;
  actions?: ReactNode;
  /** Marca o card inteiro como clicavel. Exige um link real dentro, para teclado. */
  interactive?: boolean;
}

/**
 * Card do sistema.
 *
 * A **barra colorida fina de 3px** e elemento de identidade, nao enfeite: card
 * liso e sem barra perde a marca. Ela codifica categoria ou status, sempre
 * acompanhada de rotulo textual — nenhum estado e comunicado so por cor.
 */
export function Card({
  accent = 'brand',
  accentSide = 'start',
  title,
  actions,
  interactive,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        styles.card,
        styles[`accent-${accent}`],
        accentSide === 'top' ? styles.accentTop : styles.accentStart,
        interactive && styles.interactive,
        className,
      )}
      {...rest}
    >
      {title || actions ? (
        <header className={styles.header}>
          {title ? <div className={styles.title}>{title}</div> : null}
          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </header>
      ) : null}
      {children}
    </div>
  );
}
